
import { mapState } from 'vuex';
import bagSizesMixin from '~/mixins/bagSizes';

export default {
    name: 'BagSizes',
    mixins: [bagSizesMixin],
    computed: mapState(['services']),
};

